export default{
  setSkills(state, skills){
    state.skills = skills
  },
  setErrorSkillsApi(state, errorSkillsAPI){
    state.errorSkillsAPI = errorSkillsAPI
  }
}